// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import {
    fieldDefinitionsToDefaultValuesDictionary,
    getValuesPerBreakpoint,
} from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";

export const buildResponsiveFields = (childFieldDefinitions: ChildFieldDefinition[]): FoundationFieldDefinition[] => {
    const useResponsiveOptionsField: FoundationFieldDefinition = {
        fieldType: "General",
        name: "useResponsiveOptions",
        editorTemplate: "CheckboxField",
        defaultValue: false,
    };

    const copyDataToResponsiveField: FoundationFieldDefinition = {
        name: "copy",
        displayName: "Copy Basic Options To Responsive Options",
        editorTemplate: "CopyDataToResponsiveField",
        defaultValue: true,
        fieldType: "General",
        isVisible: item => item.fields.useResponsiveOptions,
        onClick: handleCopyToResponsive => {
            handleCopyToResponsive(responsiveRows.name, [
                useResponsiveOptionsField.name,
                responsiveRows.name,
                copyDataToResponsiveField.name,
            ]);
        },
    };

    const responsiveRows: FoundationFieldDefinition = {
        name: "responsive",
        editorTemplate: "ListField",
        getDisplay: (item: HasFields) => {
            const firstFieldKey = Object.keys(item.fields)[0];
            return item.fields[firstFieldKey];
        },
        defaultValue: getValuesPerBreakpoint(fieldDefinitionsToDefaultValuesDictionary(childFieldDefinitions)),
        fieldType: "Translatable",
        hideAdd: true,
        hideDelete: true,
        isVisible: item => item.fields.useResponsiveOptions,
        fieldDefinitions: [...childFieldDefinitions],
    };

    return [useResponsiveOptionsField, copyDataToResponsiveField, responsiveRows];
};
